module.exports = __webpack_public_path__ + "static/media/startRoadMap.4a2c6f00.png";